export default __webpack_public_path__ + "static/media/slide3.7211aa4f.png";